import React from "react";

export const Button = ({ variant = "primary", className = "", children, ...props }) => {
  const base =
    "inline-flex items-center justify-center rounded-md text-sm font-semibold tracking-wide px-4 h-9 transition-colors duration-200 disabled:opacity-50 disabled:pointer-events-none";
  const variants = {
    primary: "bg-zinc-950 text-white hover:bg-zinc-800",
    accent: "bg-blue-600 text-white hover:bg-blue-700",
    danger: "bg-red-600 text-white hover:bg-red-700",
    outline: "border border-zinc-200 bg-white text-zinc-950 hover:bg-zinc-50",
    ghost: "text-zinc-700 hover:bg-zinc-100",
  };
  return (
    <button {...props} className={`${base} ${variants[variant]} ${className}`}>
      {children}
    </button>
  );
};

export const Input = ({ className = "", ...props }) => (
  <input
    {...props}
    className={`w-full bg-white border border-zinc-200 focus:border-zinc-950 focus:ring-1 focus:ring-zinc-950 rounded-md shadow-sm h-9 text-sm px-3 outline-none ${className}`}
  />
);

export const Label = ({ className = "", children, ...props }) => (
  <label
    {...props}
    className={`block text-xs font-semibold uppercase tracking-wider text-zinc-600 mb-1.5 ${className}`}
  >
    {children}
  </label>
);

export const Select = ({ className = "", children, ...props }) => (
  <select
    {...props}
    className={`w-full bg-white border border-zinc-200 focus:border-zinc-950 focus:ring-1 focus:ring-zinc-950 rounded-md shadow-sm h-9 text-sm px-2 outline-none ${className}`}
  >
    {children}
  </select>
);

export const Badge = ({ color = "zinc", children, ...props }) => {
  const colors = {
    zinc: "bg-zinc-100 text-zinc-700 border-zinc-200",
    red: "bg-red-50 text-red-700 border-red-200",
    green: "bg-green-50 text-green-700 border-green-200",
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    purple: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  };
  return (
    <span
      {...props}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-widest border ${colors[color]}`}
    >
      {children}
    </span>
  );
};

export const Card = ({ className = "", children, ...props }) => (
  <div {...props} className={`border border-zinc-200 bg-white rounded-md shadow-sm p-5 ${className}`}>
    {children}
  </div>
);

export const Spinner = () => (
  <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-900" />
);
